import { Injectable } from 'ng-metadata/core';
import { orderBy } from "lodash";
import { getBackendSystem, getVid } from '../../appConfig/appConfigForward';
import { MappingTablesCache } from "../../mappingTablesCache/mappingTablesCache.service";
import { ConfigurationUtil } from '../../nddUtils/configurationUtil.service';

@Injectable()
export class ResourceTypeFilterBarService {

    private ENABLE_RESOURCE_TYPE_FILTER = "enable_resource_type_filter_bar";

    constructor(private configurationUtil: ConfigurationUtil,
        private mappingTablesCache: MappingTablesCache) {
    }


    public isResourceTypeFilterBarEnabled() {

        let enableResourceTypeBar = this.getResourceTypeFilterConf();

        if (enableResourceTypeBar) {
            return true;
        }
        return false;
    }

    public getResourceTypeFilterConf() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,
            {source1: getVid(), source2: this.ENABLE_RESOURCE_TYPE_FILTER, target: 'true'}).length > 0;  
    }

    public getResourceTypeFilter(tab) {
        let resourceType = orderBy(this.mappingTablesCache.getTable('Prima Filter Bar Resource Types'),
            (val) => parseInt(val['source2']), 'asc');
        let resourceTypeFilterdByTab = resourceType.filter((val) => {

			if (!val['source1']) {
				return false;
			}
            
			let isExists = false;
			if (val['source1'] === 'ALL') {
				isExists = true;
			}
			let tabs = val['source1'].split(',');

			tabs.forEach((cur)=> {
				if (cur.toLowerCase() === tab.toLowerCase()) {
					isExists = true;;
				}
    		});
			return isExists;
            
			
        });
        return resourceTypeFilterdByTab.map((resource) => resource['target']);
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceTypeFilterBar/resourceTypeFilterBar.service.ts